"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Marketplace = function Marketplace(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? "#181B32" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? "" : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M44.2,18L39.7,6.4c-0.2-0.6-0.8-0.9-1.4-0.9H11.6c-0.6,0-1.1,0.4-1.4,0.9L5.8,18c-1.1,2.7-0.1,5.8,2.2,7.3v14.4 c0,2.7,2.4,4.8,5.3,4.8h23.4c2.9,0,5.3-2.2,5.3-4.8V25.3C44.3,23.8,45.3,20.7,44.2,18z M8.5,19.1l4.1-10.7h24.7l4.1,10.7 c0.6,1.5,0.1,3.2-1.2,3.8c-0.5,0.2-0.9,0.4-1.4,0.4c-1.7,0-3.2-1.4-3.2-3.2c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5 c0,1.7-1.4,3.2-3.2,3.2c-1.7,0-3.2-1.4-3.2-3.2c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5c0,1.7-1.4,3.2-3.2,3.2 c-1.7,0-3.2-1.4-3.2-3.2c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,1.7-1.4,3.2-3.2,3.2c-0.5,0-1-0.1-1.4-0.4 C8.5,22.2,7.9,20.6,8.5,19.1z M31.3,41.6H18.7V32l5.2,6c0.6,0.6,1.7,0.6,2.2,0l5.2-6V41.6z M36.7,41.6h-2.5V30c0-1-0.6-1.8-1.4-2.2 c-0.8-0.3-1.7-0.1-2.3,0.6L25,34.8l-5.5-6.3c-0.6-0.7-1.5-0.9-2.3-0.6c-0.9,0.3-1.4,1.2-1.4,2.1v11.6h-2.5c-1.3,0-2.3-0.9-2.3-1.9 V26.1c0.1,0,0.1,0,0.2,0c1.9,0,3.5-0.9,4.6-2.2c1.1,1.3,2.8,2.2,4.6,2.2c1.9,0,3.5-0.9,4.6-2.2c1.1,1.3,2.8,2.2,4.6,2.2 c1.9,0,3.5-0.9,4.6-2.2c1.1,1.3,2.8,2.2,4.6,2.2c0.1,0,0.1,0,0.2,0v13.6C39,40.8,38,41.6,36.7,41.6z"
  }));
};
var _default = exports["default"] = Marketplace;